module.exports = __webpack_public_path__ + "img/ser3.2838f75e.png";